export default "__VITE_ASSET__BRuJLmrX__"